import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgArrowRight = (props) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 24 24",
	height: "1em",
	width: "1em",
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M5 12h14",
		fill: "none",
		stroke: "var(--icon-color, currentColor)",
		strokeLinecap: "round",
		strokeLinejoin: "round",
		strokeWidth: 2
	}), /* @__PURE__ */ _jsx("path", {
		d: "m12 5 7 7-7 7",
		fill: "none",
		stroke: "var(--icon-color, currentColor)",
		strokeLinecap: "round",
		strokeLinejoin: "round",
		strokeWidth: 2
	})]
});
export default SvgArrowRight;
